const NoData = () => {
  return <div className="centered nodata">No data available for the selected dates</div>;
};

export default NoData;
